@for (item of menu; track item) {
  <li class="item">
    <a
      [attr.data-testid]="'footer-link-' + item"
      class="link"
      [title]="`links.${item}.text` | translate"
      [href]="`links.${item}.href` | translate"
      target="_blank"
      >{{ `links.${item}.text` | translate }}</a
    >
  </li>
}

<li class="item">
  @let i18nKey = 'links.cookies.text';
  @let i18nValue = i18nKey | translate;

  @if (useOneTrust() && i18nValue !== i18nKey) {
    <button
      data-testid="footer-link-cookies"
      id="ot-sdk-btn"
      class="link ot-sdk-show-settings"
      [title]="i18nValue"
      [protectInnerText]="i18nValue">
      {{ i18nValue }}
    </button>
  } @else {
    <a
      data-testid="footer-link-cookies"
      class="link"
      [title]="i18nValue"
      [href]="'links.cookies.href' | translate"
      target="_blank"
      >{{ i18nValue }}</a
    >
  }
</li>

<li class="item item--separated">
  <a
    data-testid="footer-link-report-compliance"
    class="link link--conformity"
    [title]="'links.report_compliance.text' | translate"
    href="https://www.wabteccorp.com/speak-up"
    target="_blank"
    >{{ 'links.report_compliance.text' | translate }}</a
  >
</li>
